import React from "react";
import "./TitleBar.scss";
import { useState, useEffect } from "react";

/**
 *
 * @param {
 * data - simple reactfragment which loads the
 *  black tag with information as necessary
 * } props
 * @returns
 */
export default function TitleBar(props) {
  const [partner, setPartner] = useState(props.data.partner);

  useEffect(() => {
    setPartner(props.data.partner);
  }, [props.data.partner]);

  const imgClassName = partner === "PBFL" ? "wideLogo" : "img";

  return (
    <div className="titleBarContainer">
      <img className={imgClassName} src={props.data.img} alt="trx now logo" />
      <div className="text">{props.data.fragment}</div>
    </div>
  );
}
